<template>
    <div>
        <!-- Page Hero -->
        <section class="page-hero d-flex align-items-center justify-content-center text-center text-white position-relative"
            style="background-color: #333; height: 400px; overflow: hidden;">
            <img src="https://placehold.co/1920x400/333333/666666?text=Check+Out"
                class="position-absolute w-100 h-100 object-fit-cover opacity-50" alt="Hero">
            <div class="position-relative z-1 mt-5">
                <h1 class="display-4 fw-bold font-serif mb-2">Check Out</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a href="/"
                                class="text-white text-decoration-none small">Home</a></li>
                        <li class="breadcrumb-item active text-white-50 small" aria-current="page">Check Out</li>
                    </ol>
                </nav>
            </div>
        </section>
        <div class="position-relative">
            <div class="torn-paper-edge"></div>
        </div>

        <!-- Main Content -->
        <section class="py-5 bg-light-creme">
            <div class="container mb-5">
                <!-- Stepper -->
                <div class="d-flex justify-content-center align-items-center mb-5 gap-3 stepper">
                    <div class="d-flex align-items-center gap-2 text-success">
                        <div class="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;"><i class="bi bi-check"></i></div>
                        <span>Cart</span>
                        <!-- <div class="bg-secondary opacity-25 ms-2 p-1 rounded-circle" style="width: 8px; height: 8px;"></div> -->
                    </div>
                    <div class="bg-secondary opacity-25" style="width: 100px; height: 1px;"></div>
                    <div class="d-flex align-items-center gap-2 fw-bold text-brown">
                        <div class="rounded-circle bg-brown text-white d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;">2</div>
                        <span>Check Out</span>
                    </div>
                    <div class="bg-secondary opacity-25" style="width: 100px; height: 1px;"></div>
                    <div class="d-flex align-items-center gap-2 text-muted">
                        <div class="rounded-circle border border-secondary d-flex align-items-center justify-content-center"
                            style="width: 30px; height: 30px;">3</div>
                        <span>Payment</span>
                    </div>
                </div>

                <div class="row g-5">
                    <!-- Billing Details -->
                    <!-- Billing Details -->
                    <div class="col-lg-7">
                        <h5 class="fw-bold mb-4 font-serif">Billing Details</h5>
                        <form class="row g-3">
                             <!-- Address Selection -->
                            <div class="col-12" v-if="addresses && addresses.length > 0">
                                <label for="addressSelect" class="form-label small fw-bold">Select Address</label>
                                <select id="addressSelect" class="form-select bg-transparent border-secondary" v-model="selectedAddress">
                                    <option :value="addr" v-for="addr in addresses" :key="addr.id">
                                        {{ addr.address }}{{ addr.city ? ', ' + addr.city : '' }}
                                    </option>
                                    <option value="new">+ Add New Address</option>
                                </select>
                            </div>

                            <div class="col-12">
                                <label for="name" class="form-label small fw-bold">Name</label>
                                <input type="text" class="form-control bg-transparent border-secondary" id="name" v-model="form.name" :readonly="!!user">
                                <div class="text-danger small" v-if="errors.name">{{ errors.name[0] }}</div>
                            </div>
                            
                            <template v-if="isNewAddress">
                                <div class="col-12">
                                    <label for="city" class="form-label small fw-bold">City</label>
                                    <select id="city" class="form-select bg-transparent border-secondary" v-model="form.city_id">
                                        <option value="" disabled>Select City</option>
                                        <option :value="city.id" v-for="city in cities" :key="city.id">{{ city.name }}</option>
                                    </select>
                                    <div class="text-danger small" v-if="errors.city_id">{{ errors.city_id[0] }}</div>
                                </div>
                                <div class="col-12" v-if="availableRegions.length > 0">
                                    <label for="region" class="form-label small fw-bold">Region</label>
                                    <select id="region" class="form-select bg-transparent border-secondary" v-model="form.region_id">
                                        <option value="" disabled>Select Region</option>
                                        <option :value="region.id" v-for="region in availableRegions" :key="region.id">{{ region.name }}</option>
                                    </select>
                                    <div class="text-danger small" v-if="errors.region_id">{{ errors.region_id[0] }}</div>
                                </div>
                                
                                <div class="col-12">
                                    <label for="address" class="form-label small fw-bold">Street Name</label>
                                    <input type="text" class="form-control bg-transparent border-secondary mb-2" id="address"
                                        placeholder="Street Name" v-model="form.address">
                                    <div class="text-danger small" v-if="errors.address">{{ errors.address[0] }}</div>
                                </div>
                                
                                <div class="col-12">
                                    <label for="description" class="form-label small fw-bold">Description (Optional)</label>
                                    <textarea class="form-control bg-transparent border-secondary" id="description" rows="2"
                                        placeholder="Detailed address info, building, floor, etc." v-model="form.description"></textarea>
                                </div>
                            </template>
                            
                            <div class="col-12">
                                <label for="phone" class="form-label small fw-bold">Phone</label>
                                <input type="text" class="form-control bg-transparent border-secondary" id="phone" v-model="form.phone" :readonly="!!user">
                                <div class="text-danger small" v-if="errors.phone">{{ errors.phone[0] }}</div>
                            </div>
                            <div class="col-12">
                                <label for="email" class="form-label small fw-bold">Email Address</label>
                                <input type="email" class="form-control bg-transparent border-secondary" id="email" v-model="form.email" :readonly="!!user">
                            </div>
                            
                            <!-- Hide Create Account if logged in -->
                            <div class="col-12 mt-4" v-if="!user">
                                <div class="form-check">
                                    <input class="form-check-input bg-transparent border-secondary" type="checkbox"
                                        id="createAccount" v-model="form.create_account">
                                    <label class="form-check-label small" for="createAccount">
                                        Create an account?
                                    </label>
                                </div>
                            </div>
                            
                            <!-- <div class="col-12 mt-4">
                                <div class="form-check">
                                    <input class="form-check-input bg-transparent border-secondary" type="checkbox"
                                        id="shipDifferent" v-model="form.ship_different">
                                    <label class="form-check-label small fw-bold" for="shipDifferent">
                                        Ship to a different address?
                                    </label>
                                </div>
                            </div> -->
                            <!-- <div class="col-12 mt-4">
                                <label for="notes" class="form-label small fw-bold">Order Notes (Optional)</label>
                                <textarea class="form-control bg-transparent border-secondary" id="notes" rows="4"
                                    placeholder="Notes about your order, e.g. special notes for delivery." v-model="form.notes"></textarea>
                            </div> -->
                        </form>
                    </div>

                    <!-- Order Summary -->
                    <div class="col-lg-5">
                        <div class="bg-white p-4 rounded-4 shadow-sm" v-if="cart">
                            <h5 class="fw-bold mb-4 font-serif">Your Order</h5>
                            <div class="d-flex justify-content-between border-bottom pb-2 mb-2 small fw-bold">
                                <span>Product</span>
                                <span>Subtotal</span>
                            </div>
                            <div class="d-flex justify-content-between border-bottom py-2 mb-2 small text-muted" v-for="item in cart.cart_items" :key="item.id">
                                <span>{{ item.name }} x {{ item.quantity }}</span>
                                <span>EGP {{ item.total }}</span>
                            </div>
                            
                            <div class="d-flex justify-content-between border-bottom py-2 mb-2 small fw-bold">
                                <span>Subtotal</span>
                                <span>EGP {{ cart.total }}</span>
                            </div>
                            <div class="d-flex justify-content-between border-bottom py-2 mb-2 small">
                                <span class="fw-bold">Shipping</span>
                                <span class="text-end text-muted">Free Shipping</span>
                            </div>
                            <div class="d-flex justify-content-between py-2 mb-4">
                                <span class="fw-bold fs-5">Total</span>
                                <span class="fw-bold fs-5 text-brown">EGP {{ cart.total }}</span>
                            </div>

                            <div class="mb-3">
                                <template v-if="payments && payments.length > 0">
                                    <div class="form-check mb-2" v-for="payment in payments" :key="payment.id">
                                        <input class="form-check-input border-secondary" type="radio" name="paymentMethod"
                                            :id="'payment_' + payment.id" :value="payment.id" v-model="form.payment_method">
                                        <label class="form-check-label small fw-bold" :for="'payment_' + payment.id">
                                            {{ payment.name }}
                                        </label>
                                    </div>
                                </template>
                                <div v-else class="text-muted small">No payment methods available.</div>
                            </div>

                            <p class="small text-muted mb-4">
                                Your personal data will be used to process your order, support your experience throughout
                                this website, and for other purposes described in our <a href="#"
                                    class="text-brown">privacy policy</a>.
                            </p>

                            <button class="btn btn-brown w-100 py-3 rounded-1 fw-bold" @click="placeOrder" :disabled="submitting">
                                <span v-if="submitting">Placing Order...</span>
                                <span v-else>Place Order</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        props: ['logo', 'user', 'addresses', 'cities', 'payments'],
        data() {
            return {
                cart: null,
                form: {
                    // Pre-fill if user exists
                    name: this.user ? (this.user.name || this.user.first_name + ' ' + this.user.last_name) : '',
                    // company_name: '',
                    // country: 'Egypt', // Removed as we use City/Region
                    address: '',
                    city_id: '',
                    region_id: '',
                    description: '', // Added description
                    // city: '', // Removed in favor of city_id
                    phone: this.user ? this.user.phone : '',
                    email: this.user ? this.user.email : '',
                    create_account: false,
                    ship_different: false,
                    notes: '',
                    payment_method: '', // Will be set to first payment method id if available
                    address_id: null // For selecting existing address
                },
                selectedAddress: null, // To track selected address object
                isNewAddress: false,
                loading: false,
                submitting: false,
                errors: {}
            }
        },
        watch: {
            selectedAddress(val) {
                 if (val === 'new') {
                     this.isNewAddress = true;
                     this.form.address_id = null;
                     this.form.address = '';
                     this.form.city_id = '';
                     this.form.region_id = '';
                     this.form.description = '';
                 } else if (val) {
                     this.isNewAddress = false;
                     this.form.address_id = val.id;
                     this.form.address = val.address;
                     this.form.city_id = val.city_id;
                     this.form.region_id = val.region_id;
                     this.form.description = val.description;
                 }
            },
            'form.city_id': function(newVal) {
                // optional: reset region if city changes
                // check if current region belongs to new city?
            }
        },
        mounted() {
            this.fetchCart();
            if (this.addresses && this.addresses.length > 0) {
                 this.selectedAddress = this.addresses[0]; // Default to first address
            } else {
                 this.isNewAddress = true; // Force new address if none exist
            }
            // Auto-select first payment method
            if (this.payments && this.payments.length > 0) {
                this.form.payment_method = this.payments[0].id;
            }
        },
        computed: {
             availableRegions() {
                 if (!this.form.city_id || !this.cities) return [];
                 const city = this.cities.find(c => c.id === this.form.city_id);
                 return city ? city.regions : [];
             }
        },
        methods: {
            fetchCart() {
                this.loading = true;
                axios.get('/api/frontend/cart')
                    .then(response => {
                        const carts = response.data.data;
                        if (Array.isArray(carts) && carts.length > 0) {
                             this.cart = carts[0];
                        } else {
                            this.cart = null;
                            // Redirect to cart if empty?
                            // window.location.href = '/cart';
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching cart:', error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            placeOrder() {
                this.submitting = true;
                this.errors = {};
                
                // If using existing address, we might need to send address_id
                // CheckoutController needs to handle 'address_id' OR 'address' text
                
                axios.post('/api/frontend/checkout', this.form)
                    .then(response => {
                        // Order placed
                        const order = response.data.data;
                        console.log('Order placed:', order);
                        // Redirect to success page or home
                        alert('Order placed successfully!');
                        window.location.href = '/'; 
                        // Or show success modal
                    })
                    .catch(error => {
                        console.error('Error placing order:', error);
                        if (error.response && error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        } else {
                            alert('An error occurred while placing the order.');
                        }
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            }
        }
    }
</script>
